import React from 'react'

const Footer = () => {

    const currentYear = new Date().getFullYear();

  return (
   <div className="row m-0 p-0">
    <div className="col-md-12" style={{display:"flex",justifyContent:"center",alignItems:"center",padding:"10px",fontSize:"12px",backgroundColor:"#000",color:"#fff"}}>
        <span>Copyright &copy; {currentYear} | Design & Developed By <a href="https://www.technoaarv.com/" target='_blank' style={{cursor:"pointer",color:"white",textDecoration:"none"}}>TechnoAarv Solution</a></span>        
    </div>
   </div>
  )
}

export default Footer